import { AirplaneIcon, BuildingsIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "@/components/Errors/PageError";

interface OfferNotAvailableErrorProps {
  variant: "flight" | "hotel";
}

export const OfferNotAvailableError = ({
  variant,
}: OfferNotAvailableErrorProps) => {
  const intl = useIntl();
  const Icon = variant === "flight" ? AirplaneIcon : BuildingsIcon;

  return (
    <PageError
      title={
        variant === "flight"
          ? intl.formatMessage({
              defaultMessage: "This flight offer is not available anymore",
              description: "flights.notAvailable.title",
            })
          : intl.formatMessage({
              defaultMessage: "This hotel offer is not available anymore",
              description: "hotels.notAvailable.title",
            })
      }
      subtitles={[
        variant === "flight"
          ? intl.formatMessage({
              defaultMessage:
                "Unfortunately, this flight offer is not available anymore. Please try again later or choose another flight.",
              description: "flights.notAvailable.description",
            })
          : intl.formatMessage({
              defaultMessage:
                "Unfortunately, this hotel offer is not available anymore. Please try again later or choose another hotel.",
              description: "hotels.notAvailable.description",
            }),
      ]}
      back={{
        text:
          variant === "flight"
            ? intl.formatMessage({
                defaultMessage: "Back to search",
                description: "flights.notAvailable.button",
              })
            : intl.formatMessage({
                defaultMessage: "Back to search",
                description: "hotels.notAvailable.button",
              }),
        options: {
          to: variant === "flight" ? "/flights/departure/list" : "/hotels/list",
        },
      }}
      icon={<Icon size={60} color="var(--color-text-interactive)" />}
    />
  );
};
